import dash_api from '../../../../main/support/dash_api';
import type { UiRoleId } from '../../../../main/types/accessControlTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { DataAction } from '../../../types/dataAction.type';

const GetRole = new ReduxAsyncAction<'GET_ROLE', void, { access_role_id: UiRoleId }>('GET_ROLE');

GetRole.registerRequest(function () {
  return dash_api.get('/v1/dashboard-user/role').then(({ data }) => {
    return {
      access_role_id: data.access_role_id,
    };
  });
});

export const GET_ROLE = GetRole.actionNamespaceConstants;

export const getRole = GetRole.request;

// for legacy calls
export const loadRole = GetRole.request;

export type GetRoleResponseAction = DataAction<typeof GET_ROLE.response, { access_role_id: UiRoleId }>;
